(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function(){
  function setFooterState(){
    var mobile = window.matchMedia('(max-width: 760px)').matches;
    document.querySelectorAll('.drmr-footer__group').forEach(function(group){
      if(mobile){ group.removeAttribute('open'); }
      else { group.setAttribute('open',''); }
    });
  }
  setFooterState();
  window.addEventListener('resize', setFooterState);
  document.addEventListener('shopify:section:load', setFooterState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function initDrmrGalleries(){
document.querySelectorAll('[data-drmr-gallery]').forEach(function(g){
if(g.dataset.ready)return;
var t=g.querySelector('.drmr-gallery__track'),p=g.querySelector('[data-gallery-prev]'),n=g.querySelector('[data-gallery-next]'),c=g.querySelector('[data-gallery-count]'),thumbs=g.querySelector('[data-gallery-thumbnails]'),items=Array.from(t.children),buttons=[],active=0;
if(!items.length)return;
g.dataset.ready='true';g.classList.add('drmr-gallery--ready');thumbs.replaceChildren();
function go(i){
active=Math.max(0,Math.min(items.length-1,i));
items.forEach(function(item,j){item.hidden=j!==active;item.setAttribute('aria-hidden',String(j!==active));if(j!==active)item.querySelectorAll('video').forEach(function(v){v.pause();});});
c.textContent=(active+1)+' / '+items.length;p.disabled=active===0;n.disabled=active===items.length-1;
buttons.forEach(function(entry){entry.button.setAttribute('aria-current',String(entry.index===active));});
}
items.forEach(function(item,i){
var image=item.querySelector('img'),b=document.createElement('button');b.type='button';b.setAttribute('aria-label',image&&image.alt||'View '+(i+1));b.setAttribute('aria-controls',t.id);
if(image){var content=item.querySelector('.drmr-gallery__single')||image;b.appendChild(content.cloneNode(true));}else{b.textContent=String(i+1);}
b.addEventListener('click',function(){go(i);});thumbs.appendChild(b);buttons.push({button:b,index:i});
});
p.addEventListener('click',function(){go(active-1);});n.addEventListener('click',function(){go(active+1);});
t.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(active+(e.key==='ArrowRight'?1:-1));}else if(e.key==='Home'){e.preventDefault();go(0);}else if(e.key==='End'){e.preventDefault();go(items.length-1);}});
var start=null;
t.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});
t.addEventListener('touchend',function(e){if(!start)return;var touch=e.changedTouches[0],dx=touch.clientX-start.x,dy=touch.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4)go(active+(dx<0?1:-1));},{passive:true});
t.addEventListener('touchcancel',function(){start=null;},{passive:true});go(0);
});}
initDrmrGalleries();document.addEventListener('shopify:section:load',initDrmrGalleries);

  } catch(e) { console.error(e); }
})();
})();
